@if (isAuthenticated() && isAdmin()) {
  <aura-workbench [title]="'Développeurs'">
    <div workbench-summary class="text-xs text-slate-11 flex items-center gap-2">
      <span class="capitalize">{{ environment.appName }} v{{ environment.version }}</span>
      <span
        class="px-1.5 py-0.5 rounded bg-blue-3 text-blue-11 border border-blue-6 uppercase text-[10px] font-semibold tracking-wider"
        >{{ environment.name }}</span
      >
    </div>

    <mat-tab-group [selectedIndex]="1" class="text-slate-11">
      <mat-tab label="Aperçu">
        <div class="p-4 grid grid-cols-2 gap-4">
          <div class="bg-slate-2 border border-slate-6 rounded-lg p-4 shadow-sm">
            <h3 class="font-medium text-slate-11 mb-2 text-sm">Requêtes API</h3>
            <div class="text-3xl font-light text-slate-12">90</div>
          </div>
          <div class="bg-slate-2 border border-slate-6 rounded-lg p-4 shadow-sm">
            <h3 class="font-medium text-slate-11 mb-2 text-sm">Événements envoyés</h3>
            <div class="text-3xl font-light text-slate-12">494</div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Webhooks">
        <div class="p-4 space-y-4 max-w-4xl">
          <h3 class="text-lg font-medium text-slate-12 mb-4">Stripe Webhooks & Subscriptions</h3>
          <div class="bg-slate-2 border border-slate-6 rounded-lg p-5 shadow-sm">
            <div class="flex items-start justify-between">
              <div>
                <h4 class="font-medium text-slate-12">Reconciliation des abonnements</h4>
                <p class="text-sm text-slate-11 mt-1">
                  Permet de vérifier les événements Stripe manqués et de les rejouer sur le système interne.
                </p>
              </div>
              <button (click)="reconcileStripe()" [disabled]="isReconciling()" mat-button class="primary">
                {{ isReconciling() ? 'Exécution...' : 'Lancer la réconciliation' }}
              </button>
            </div>

            @if (reconcileResult()) {
              <div class="mt-4 p-4 bg-slate-3 border border-slate-6 rounded-md text-sm">
                <div class="flex items-center gap-2 mb-2 text-green-11">
                  <mat-icon class="!text-[20px] !w-5 !h-5 flex items-center justify-center"
                    >check_circle</mat-icon
                  >
                  <span class="font-medium">Réconciliation terminée avec succès</span>
                </div>
                <ul class="space-y-1 text-slate-11 ml-7">
                  <li>
                    Événements vérifiés :
                    <span class="text-slate-12">{{ reconcileResult()?.eventsChecked }}</span>
                  </li>
                  <li>
                    Événements réconciliés :
                    <span class="text-slate-12">{{ reconcileResult()?.eventsReconciled }}</span>
                  </li>
                </ul>
              </div>
            }
          </div>

          <!-- Zammad Webhooks & Tickets -->
          <h3 class="text-lg font-medium text-slate-12 mt-6 mb-4">Zammad Webhooks & Tickets</h3>
          <div class="bg-slate-2 border border-slate-6 rounded-lg p-5 shadow-sm">
            <div class="flex items-start justify-between">
              <div>
                <h4 class="font-medium text-slate-12">Reconciliation des tickets</h4>
                <p class="text-sm text-slate-11 mt-1">
                  Permet de vérifier les tickets modifiés sur Zammad récemment et de synchroniser le système
                  interne.
                </p>
              </div>
              <button
                (click)="reconcileZammad()"
                [disabled]="isReconcilingZammad()"
                mat-button
                class="primary"
              >
                {{ isReconcilingZammad() ? 'Exécution...' : 'Lancer la réconciliation' }}
              </button>
            </div>

            @if (zammadReconcileResult()) {
              <div class="mt-4 p-4 bg-slate-3 border border-slate-6 rounded-md text-sm">
                <div class="flex items-center gap-2 mb-2 text-green-11">
                  <mat-icon class="!text-[20px] !w-5 !h-5 flex items-center justify-center"
                    >check_circle</mat-icon
                  >
                  <span class="font-medium">Réconciliation terminée avec succès</span>
                </div>
                <ul class="space-y-1 text-slate-11 ml-7">
                  <li>
                    Tickets vérifiés :
                    <span class="text-slate-12">{{ zammadReconcileResult()?.ticketsChecked }}</span>
                  </li>
                  <li>
                    Tickets réconciliés :
                    <span class="text-slate-12">{{ zammadReconcileResult()?.ticketsReconciled }}</span>
                  </li>
                </ul>
              </div>
            }
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Événements">
        <div class="p-4 flex flex-col items-center justify-center h-[200px] text-slate-11">
          <mat-icon class="!text-[48px] !w-12 !h-12 flex items-center justify-center mb-4 opacity-50"
            >warning</mat-icon
          >
          <p>Module en cours de construction</p>
        </div>
      </mat-tab>
    </mat-tab-group>
  </aura-workbench>
}
